export default __webpack_public_path__ + "static/media/eng_1.c0e2c3dc.png";